import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CareerOneStopVideoIconComponent, CareerOneStopVideoDialog } from './career-one-stop-video.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule
	],
	declarations: [
		CareerOneStopVideoIconComponent,
		CareerOneStopVideoDialog
	],
	exports: [
		CareerOneStopVideoIconComponent,
		CareerOneStopVideoDialog
	]
})
export class CareerOneStopVideoComponentModule { }
